import { render, staticRenderFns } from "./CourseScorm.vue?vue&type=template&id=60afdd54&scoped=true&"
import script from "./CourseScorm.vue?vue&type=script&lang=js&"
export * from "./CourseScorm.vue?vue&type=script&lang=js&"
import style0 from "./CourseScorm.vue?vue&type=style&index=0&id=60afdd54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afdd54",
  null
  
)

component.options.__file = "CourseScorm.vue"
export default component.exports